var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcUsdt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#84l2vmbofa)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.017 8.952V7.717h2.803V5.834H6.19v1.883H8.99v1.234C6.713 9.057 5 9.511 5 10.057c0 .545 1.713 1 3.991 1.106v3.957h2.026V11.16c2.273-.105 3.983-.56 3.983-1.104 0-.545-1.709-1-3.983-1.106v.001zm0 1.873c-.056.005-.35.023-1.005.023-.52 0-.89-.016-1.02-.023-2.013-.089-3.516-.442-3.516-.865s1.503-.776 3.516-.866v1.38c.131.01.508.032 1.03.032.624 0 .937-.027.993-.032v-1.38c2.01.09 3.508.444 3.508.866s-1.498.775-3.508.865h.002z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "84l2vmbofa",
    x1: -10.302,
    y1: 10,
    x2: 9.698,
    y2: 30.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#148461"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsdt);
export default __webpack_public_path__ + "static/media/ic-usdt.9956bf4496cbf0f1e8a3b26647e160b7.svg";
export { ForwardRef as ReactComponent };